import Api from './api.service';

export default {
  get: () => Api.get('permissions'),
};
